/**
 * 领红包共享逻辑(SDK + 主流程复用)
 *
 * 纯函数,不依赖 date-fns / @/libutils(避免经 barrel 把 locale 拉进 SDK bundle)。
 * SDK 侧(@/sdk)与主流程侧(@/components)各自的 claimCoupon 实现不同(SDK fetch / 主流程 axios),
 * 故 claimFn 由调用方注入;编排逻辑(allSettled 统计成败)+ 错误描述在此共享,消除漂移。
 */
import type { GroupCoupon } from '@/types/coupon';

/** 领取结果(成功张数 + 失败明细) */
export interface ClaimResult {
  success: number;
  failed: { name: string; reason: string }[];
}

/** 把 claim 失败转为中文原因(按错误码粗分,上游错误码未透出) */
export function describeClaimError(err: unknown): string {
  const code = (err as { code?: number })?.code;
  if (code === 401) return '未登录';
  if (code === 404) return '券不存在';
  if (code === 400) return '库存不足或已过期';
  return '领取失败';
}

/**
 * 一键领取:并发领取所有未领券(allSettled),不抛错,逐张统计成败。
 * @param unclaimed 未领取的券(claimed 非 true;未传 member_phone 时 claimed 为 null,全部视为可领)
 * @param claimFn 单张券领取函数(注入:主流程 axios / SDK fetch 各自实现)
 */
export async function runClaimAll(
  unclaimed: GroupCoupon[],
  claimFn: (coupon: GroupCoupon) => Promise<unknown>
): Promise<ClaimResult> {
  const settled = await Promise.allSettled(unclaimed.map((c) => claimFn(c)));
  const failed: { name: string; reason: string }[] = [];
  let success = 0;
  settled.forEach((r, i) => {
    if (r.status === 'fulfilled') success++;
    else failed.push({ name: unclaimed[i].name, reason: describeClaimError(r.reason) });
  });
  return { success, failed };
}
